import React from "react";

const FieldDropdown = ({ value, options, onChange, label, disabled = false }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full px-2 py-1.5 bg-white rounded-md text-sm border border-gray-300 hover:border-blue-600 focus:ring-blue-500 focus:outline-none disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <option value="">Select an option</option>
        {options.map((option, idx) => {
          // If option is an object, extract value & label
          const optionValue = typeof option === "object" ? option.value : option;
          const optionLabel = typeof option === "object" ? option.label : option;

          return (
            <option key={idx} value={optionValue}>
              {optionLabel}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default FieldDropdown;
